import React from "react";
import Fallback from "../../components/Fallback";

const AdsManager = React.lazy(() => import("./AdsManager"));
export const AdsManagerScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <AdsManager {...props} />
  </React.Suspense>
);
